// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","inner":"Header_inner__t9aII","logo":"Header_logo__G+ea6","burger":"Header_burger__wqs1s","mobileNav":"Header_mobileNav__z6sVY"};